import React from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Badge, Popover } from "antd";

const OrderIDTitle = () => {
  const content = (
    <div className="tag-description-box">
      <Badge status="default" /> Cancelled Order
    </div>
  );

  return (
    <div className="order-id-title">
      <div>
        Order ID{" "}
        <Popover content={content}>
          <QuestionCircleOutlined className="shipment-tag-description-trigger" />
        </Popover>
      </div>
    </div>
  );
};

export default OrderIDTitle;
